<sc-activity-list-item [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed">
    <i scActivityIcon class="fa-sharp fa-solid fa-globe"></i>
    {{ texts.jobsiteReady[language] }}
    <div scActivityBody>
        <a href="https://app.skillconomy.com/projects/{{ activity.Project?.Id }}/jobsite-review" target="_blank">{{ texts.jobsiteLink[language] }} {{ activity.Project?.Name }} {{ texts.genderSuffix[language] }}</a>
    </div>
</sc-activity-list-item>
